// extracted by mini-css-extract-plugin
module.exports = {"AddTaskOption":"styles_AddTaskOption__lZpPh"};